<template>
  <SidebarProvider
    v-model:open="open"
    :keyboard-shortcut="hasAside ? 'b' : null"
    mobile-query="(max-width: 991.98px)"
    :style="{
      '--sidebar-width': '265px',
      '--sidebar-width-icon': '70px',
    }"
  >
    <slot />
  </SidebarProvider>
</template>

<script setup>
import { watchImmediate } from '@vueuse/core'
import Store from 'store'
import { computed, provide, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import StorageKeys from '@/common/storage-keys.js'
import { SidebarProvider } from '@/shadcn/components/ui/sidebar'

const props = defineProps({
  brandLogo: { type: String, required: false, default: '' },
})

provide('asideBrandLogo', props.brandLogo)

const route = useRoute()
const groupRoute = computed(() => route.matched.find(r => r.meta.group !== undefined))

const open = ref(true)

// The provider wraps every v5 layout, including $noAside blades; without an
// aside there is nothing to toggle, so disable the shortcut and body class.
const hasAside = document.body.classList.contains('aside-enabled')

// Restore the per-route-group state (same storage keys the old Metronic aside used).
watchImmediate(groupRoute, (group) => {
  if (!group) {
    return
  }

  const minimized = Store.get(`${StorageKeys.ASIDE_MINIMIZED}:${group.meta.group}`)

  open.value = minimized === undefined
    ? group.meta['aside-minimized'] !== true
    : minimized !== '1'
})

watch(open, (value) => {
  if (groupRoute.value) {
    Store.set(`${StorageKeys.ASIDE_MINIMIZED}:${groupRoute.value.meta.group}`, value ? '0' : '1')
  }
})

// The Metronic fixed header/subheader offsets are keyed off this body class.
watchImmediate(open, (value) => {
  document.body.classList.toggle('aside-minimize', hasAside && !value)
})
</script>
